export default __webpack_public_path__ + "static/media/mashoorah-logo-white.7ce4ca0e.svg";